import { isEmail, validateFullName } from '@/common/validators';

// import { fullNameFormat } from '@/common/textFormater';

const disableBlacklistValue = import.meta.env
  .VITE_DISABLE_BLACKLIST_FOR_SIGNUP_NAME;

export default {
  data() {
    return {
      full_name: '',
      email_address: '',
      full_name_error: '',
      full_name_alert: '',
      full_name_error_sw: '',
      email_address_error: '',
    };
  },
  computed: {
    isIDVOnboardingActive() {
      return this.$store.getters['users/getFeatureFlag']?.(
        'idv_onboarding_flow'
      )?.['enabled'];
    },
    carrierName() {
      return this.$store.state.carriers?.carrierDetails?.name || null;
    },
    disableBlackListForSignUp() {
      // 1 would mean that we do want to disable that logic, any other value should mean that we want it enabled.
      return disableBlacklistValue == 1;
    },
  },
  methods: {
    isFullNameField(fieldName) {
      const name = fieldName.toLowerCase();
      if (name.includes('full') && name.includes('name')) {
        return true;
      }
      return false;
    },
    // checkFullname() {
    //   this.full_name_error = "";
    //   const is_valid_fullname = fullnameValidation(this.full_name);
    //   if(is_valid_fullname !== true) this.full_name_error = is_valid_fullname;
    // },
    handleFieldUpdate(e) {
      let value = e.target.value;
      // if (this.isFullNameField(e.target.name)) {
      //   value = fullNameFormat(value);
      // }
      if (this[`${e.target.name}_error`]) this[`${e.target.name}_error`] = '';
      this[e.target.name] = value;
      this.$store.commit('updateSignupField', {
        name: e.target.name,
        value: value,
      });
    },
    checkEmailAddress(email_address) {
      const email =
        email_address?.target?.value ||
        email_address?.value ||
        this.email_address ||
        null;
      if (!email) {
        this.email_address_error = 'This field is required.';
        return;
      }
      this.email_address_error = '';
      const validEmail = isEmail(email);
      if (!validEmail)
        this.email_address_error = 'Please enter a valid email address.';
    },
  },

  watch: {
    full_name(newVal) {
      //If IDV onboarding is active, we don't want to validate the full name
      // as it was validated in the IDV flow.

      if (this.isIDVOnboardingActive) return;
      const validationResult = validateFullName(
        newVal,
        this.carrierName,
        this.disableBlackListForSignUp,
        this
      );

      // Reset error and alert messages
      this.full_name_error = '';
      this.full_name_error_sw = '';
      this.full_name_alert = '';

      if (validationResult?.alertMessage) {
        this.full_name_alert = validationResult.alertMessage;
      } else if (!validationResult.isValid) {
        this.full_name_error_sw =
          'exist an error. line 67 mixins/fullnameAndEmailField.js';
        this.full_name_error = validationResult.message;
      }
    },
  },
};
